import { Link } from "react-router-dom";
import { FaBell } from "react-icons/fa";

import useUnreadNotificationsCount from "../../customHooks/useUnreadNotificationsCount";

import "./NotificationBell.scss";

export default function NotificationBell({ onClick }) {
  const { count } = useUnreadNotificationsCount();

  return (
    <Link
      to="/emp/nofications"
      className="notification-bell"
      onClick={onClick}
      aria-label="الإشعارات"
    >
      <FaBell className="notification-bell__icon" />
      {count > 0 && (
        <span className="notification-bell__badge">{count > 99 ? "99+" : count}</span>
      )}
    </Link>
  );
}
